import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description: string;
  path?: string;
}

function setMeta(attr: string, key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

const SITE_URL = "https://faeverse.github.io";

/**
 * 轻量站内 SEO 助手：更新页面 title、description 与 Open Graph 标签。
 */
export default function useSeo({ title, description, path = "/" }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", `${SITE_URL}${path}`);
    const canonical = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (canonical) canonical.setAttribute("href", `${SITE_URL}${path}`);
  }, [title, description, path]);
}